import React, { useEffect, useState } from "react";
import "./despre_noi-style.css";
import "../common-style.css";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Footer } from "../../Components/Footer/footer";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import YouTube from "react-youtube";

// fallback local
import Slide1 from "../../Assets/slide-1.jpeg";
import Slide2 from "../../Assets/slide-2.jpeg";
import Voucher1 from "../../Assets/voucher-1.png";
import Voucher2 from "../../Assets/voucher-2.png";
import Voucher3 from "../../Assets/voucher-3.png";
import Voucher4 from "../../Assets/voucher-4.png";
import Voucher5 from "../../Assets/voucher-5.png";
import Voucher6 from "../../Assets/Voucher6.png";

interface DespreNoiConfig {
    slides: string[];
    slideLinks?: string[];       // link-uri opționale pentru slide-uri
    vouchers: string[];
    voucherLinks?: string[];     // link-uri opționale pentru vouchere
    videoId: string;
    beneficiiTitle: string;
    videoTitle: string;
}

const fallback: DespreNoiConfig = {
    slides: [Slide1, Slide2],
    slideLinks: [
        "https://www.sanitasbucuresti.ro/membri-de-sindicat",
        "https://www.sanitasbucuresti.ro/despre-noi",
    ],
    vouchers: [Voucher1, Voucher2, Voucher3, Voucher4, Voucher5, Voucher6],
    voucherLinks: [], // implicit fără link pentru vouchere
    videoId: "FlFUbG6KaYM",
    beneficiiTitle: "Beneficiile membrilor",
    videoTitle: "Ghid pas cu pas pentru înscrierea în aplicația Smart Sanitas",
};

export function DespreNoiPage() {
    const [cfg, setCfg] = useState<DespreNoiConfig | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const snap = await getDoc(doc(db, "siteContent", "despreNoi"));
                if (snap.exists()) {
                    const data = snap.data() as Partial<DespreNoiConfig>;

                    setCfg({
                        slides:
                            data.slides && data.slides.length
                                ? data.slides
                                : fallback.slides,
                        slideLinks:
                            data.slideLinks && data.slideLinks.length
                                ? data.slideLinks
                                : fallback.slideLinks,
                        vouchers:
                            data.vouchers && data.vouchers.length
                                ? data.vouchers
                                : fallback.vouchers,
                        voucherLinks:
                            data.voucherLinks && data.voucherLinks.length
                                ? data.voucherLinks
                                : fallback.voucherLinks,
                        videoId: data.videoId || fallback.videoId,
                        beneficiiTitle:
                            data.beneficiiTitle || fallback.beneficiiTitle,
                        videoTitle: data.videoTitle || fallback.videoTitle,
                    });
                } else {
                    setCfg(fallback);
                }
            } catch (e) {
                console.error(e);
                setCfg(fallback);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    const content = cfg || fallback;

    return (
        <div className="page-container">
            <Navbar />
            <div className="page-content">
                {loading ? (
                    <div style={{ padding: "3rem", textAlign: "center" }}>
                        Se încarcă...
                    </div>
                ) : (
                    <>
                        {/* SLIDER PRINCIPAL */}
                        <Carousel
                            className="carousel"
                            infiniteLoop
                            width="90%"
                            showStatus={false}
                            showThumbs={false}
                            autoPlay={true}
                            interval={5000}
                            transitionTime={800}
                            stopOnHover={true}
                        >
                            {content.slides.map((src, i) => {
                                const link = content.slideLinks?.[i];
                                return (
                                    <div key={i}>
                                        {link ? (
                                            <a
                                                href={link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img
                                                    src={src}
                                                    alt={`Slide ${i + 1}`}
                                                />
                                            </a>
                                        ) : (
                                            <img
                                                src={src}
                                                alt={`Slide ${i + 1}`}
                                            />
                                        )}
                                    </div>
                                );
                            })}
                        </Carousel>

                        {/* VOUCHERE */}
                        <div className="voucher-box">
                            <h1>{content.beneficiiTitle}</h1>
                            <Carousel
                                className="carousel"
                                infiniteLoop
                                width="90%"
                                showStatus={false}
                                showThumbs={false}
                                autoPlay={true}
                                interval={5000}
                                transitionTime={800}
                                stopOnHover={true}
                            >
                                {content.vouchers.map((src, i) => {
                                    const link = content.voucherLinks?.[i];
                                    return (
                                        <div key={i}>
                                            {link ? (
                                                <a
                                                    href={link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img
                                                        src={src}
                                                        alt={`Voucher ${i + 1}`}
                                                    />
                                                </a>
                                            ) : (
                                                <img
                                                    src={src}
                                                    alt={`Voucher ${i + 1}`}
                                                />
                                            )}
                                        </div>
                                    );
                                })}
                            </Carousel>
                        </div>

                        {/* VIDEO */}
                        <div className="video-box">
                            <h1>{content.videoTitle}</h1>
                            <YouTube
                                className="youtube"
                                videoId={content.videoId}
                                opts={{
                                    playerVars: {
                                        start: 0,
                                        autoplay: 0,
                                        color: "white",
                                        modestbranding: 1,
                                        controls: 1,
                                        rel: 0,
                                        loop: 1,
                                    },
                                }}
                            />
                        </div>
                    </>
                )}
            </div>
            <Footer />
        </div>
    );
}